module.exports = __webpack_public_path__ + "static/media/dhruv_sadhale.22290e44.png";